import { PricingSheet } from "../types";
import { isBefore } from "date-fns";

const isPricingSheetExpired = (sheet: PricingSheet) => {
  if (!sheet.to) {
    return false;
  }
  return isBefore(new Date(sheet.to), new Date());
};

export default isPricingSheetExpired;
